import { useState } from 'react';

import useEffectOnce from '@app/hooks/useEffectOnce';

import Slide from './Slide';
import {
    SlideCarouselIndicator,
    SlideCarouselIndicatorContainer,
    SlideTrack,
    SocialProofCarouselContainer,
} from './styles';
import { SLIDES } from './utils';

const SocialProofCarousel = () => {
    const [currentSlideIdx, setCurrentSlideIdx] = useState(0);

    useEffectOnce(() => {
        const interval = setInterval(() => {
            setCurrentSlideIdx((prevCurrentSlideIdx) =>
                prevCurrentSlideIdx === SLIDES.length - 1 ? 0 : prevCurrentSlideIdx + 1,
            );
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    });

    return (
        <SocialProofCarouselContainer data-testid="social-proof-carousel-container">
            <SlideTrack
                style={{
                    transform: `translateX(calc(440px - 400px)) translateX(calc(-400px * ${currentSlideIdx}))`,
                }}
            >
                {SLIDES.map((slide, idx) => (
                    <Slide
                        key={slide.title}
                        title={slide.title}
                        description={slide.description}
                        imageSrc={slide.imageSrc}
                        isActive={idx === currentSlideIdx}
                        companyLogos={slide.companyLogos}
                    />
                ))}
            </SlideTrack>
            <SlideCarouselIndicatorContainer data-testid="slide-carousel-indicator-container" justify="center">
                {SLIDES.map((slide, idx) => (
                    <SlideCarouselIndicator
                        key={slide.id}
                        $isActive={idx === currentSlideIdx}
                        type="button"
                        onClick={() => {
                            setCurrentSlideIdx(idx);
                        }}
                    />
                ))}
            </SlideCarouselIndicatorContainer>
        </SocialProofCarouselContainer>
    );
};

export default SocialProofCarousel;
